import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

export default function PushNotificationPrompt({ onDismiss }) {
  const { canRequest, requestPermission, isSupported } = usePushNotifications();

  if (!isSupported || !canRequest) return null;

  const handleAllow = async () => {
    await requestPermission();
    onDismiss?.();
  };

  return (
    <div className="mt-6 p-4 bg-primary-50 rounded-xl border border-primary-100">
      <p className="text-sm font-medium text-gray-800 mb-2">
        Activer les notifications ?
      </p>
      <p className="text-sm text-gray-600 mb-3">
        Recevez une alerte pour les prochains micro-sondages (ex. &quot;Comment vous sentez-vous cette semaine ?&quot;).
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={handleAllow}
          className="px-4 py-2 text-sm font-medium bg-primary-600 text-white rounded-lg hover:bg-primary-700"
        >
          Activer
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
        >
          Non merci
        </button>
      </div>
    </div>
  );
}
